'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pagination = require('./modules/pagination');

var _absenteeBid = require('./modules/absenteeBid');

var _absenteeBid2 = _interopRequireDefault(_absenteeBid);

var _analytics = require('./modules/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _autoPopModal = require('./modules/autoPopModal');

var _autoPopModal2 = _interopRequireDefault(_autoPopModal);

var _bidderExists = require('./modules/bidderExists');

var _bidderExists2 = _interopRequireDefault(_bidderExists);

var _biddingInfo = require('./modules/biddingInfo');

var _biddingInfo2 = _interopRequireDefault(_biddingInfo);

var _bidHistory = require('./modules/bidHistory');

var _bidHistory2 = _interopRequireDefault(_bidHistory);

var _bidIncrements = require('./modules/bidIncrements');

var _bidIncrements2 = _interopRequireDefault(_bidIncrements);

var _browser = require('./modules/browser');

var _browser2 = _interopRequireDefault(_browser);

var _catalog = require('./modules/catalog');

var _catalog2 = _interopRequireDefault(_catalog);

var _catalogCurators = require('./modules/catalogCurators');

var _catalogCurators2 = _interopRequireDefault(_catalogCurators);

var _catalogDetail = require('./modules/catalogDetail');

var _catalogDetail2 = _interopRequireDefault(_catalogDetail);

var _catalogLocation = require('./modules/catalogLocation');

var _catalogLocation2 = _interopRequireDefault(_catalogLocation);

var _catalogRegistration = require('./modules/catalogRegistration');

var _catalogRegistration2 = _interopRequireDefault(_catalogRegistration);

var _redux = require('redux');

var _completeAccount = require('./modules/completeAccount');

var _completeAccount2 = _interopRequireDefault(_completeAccount);

var _config = require('./modules/config');

var _config2 = _interopRequireDefault(_config);

var _confirmPassword = require('./modules/confirmPassword');

var _confirmPassword2 = _interopRequireDefault(_confirmPassword);

var _consignment = require('./modules/consignment');

var _consignment2 = _interopRequireDefault(_consignment);

var _console = require('./modules/console');

var _console2 = _interopRequireDefault(_console);

var _coverLots = require('./modules/coverLots');

var _coverLots2 = _interopRequireDefault(_coverLots);

var _createAccount = require('./modules/createAccount');

var _createAccount2 = _interopRequireDefault(_createAccount);

var _emailList = require('./modules/emailList');

var _emailList2 = _interopRequireDefault(_emailList);

var _errors = require('./modules/errors');

var _errors2 = _interopRequireDefault(_errors);

var _fetchBatch = require('./modules/fetchBatch');

var _fetchBatch2 = _interopRequireDefault(_fetchBatch);

var _followSeller = require('./modules/followSeller');

var _followSeller2 = _interopRequireDefault(_followSeller);

var _forgotPassword = require('./modules/forgotPassword');

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _headerSearchDropdown = require('./modules/headerSearchDropdown');

var _headerSearchDropdown2 = _interopRequireDefault(_headerSearchDropdown);

var _healthcheck = require('./modules/healthcheck');

var _healthcheck2 = _interopRequireDefault(_healthcheck);

var _home = require('./modules/home');

var _home2 = _interopRequireDefault(_home);

var _imageGalleryActiveImage = require('./modules/imageGalleryActiveImage');

var _imageGalleryActiveImage2 = _interopRequireDefault(_imageGalleryActiveImage);

var _reactIntlRedux = require('react-intl-redux');

var _item = require('./modules/item');

var _item2 = _interopRequireDefault(_item);

var _itemDescription = require('./modules/itemDescription');

var _itemDescription2 = _interopRequireDefault(_itemDescription);

var _itemDetail = require('./modules/itemDetail');

var _itemDetail2 = _interopRequireDefault(_itemDetail);

var _itemFacets = require('./modules/itemFacets');

var _itemFacets2 = _interopRequireDefault(_itemFacets);

var _landingPage = require('./modules/landingPage');

var _landingPage2 = _interopRequireDefault(_landingPage);

var _loaded = require('./modules/loaded');

var _loaded2 = _interopRequireDefault(_loaded);

var _login = require('./modules/login');

var _login2 = _interopRequireDefault(_login);

var _modal = require('./modules/modal');

var _modal2 = _interopRequireDefault(_modal);

var _moreItemsFromCatalogIndex = require('./modules/moreItemsFromCatalogIndex');

var _moreItemsFromCatalogIndex2 = _interopRequireDefault(_moreItemsFromCatalogIndex);

var _reduxAsyncConnect = require('@liveauctioneers/redux-async-connect');

var _registerForCatalog = require('./modules/registerForCatalog');

var _registerForCatalog2 = _interopRequireDefault(_registerForCatalog);

var _retractBid = require('./modules/retractBid');

var _retractBid2 = _interopRequireDefault(_retractBid);

var _route = require('./modules/route');

var _route2 = _interopRequireDefault(_route);

var _reactRouterRedux = require('react-router-redux');

var _savedItemCount = require('./modules/savedItemCount');

var _savedItemCount2 = _interopRequireDefault(_savedItemCount);

var _savedSearch = require('./modules/savedSearch');

var _savedSearch2 = _interopRequireDefault(_savedSearch);

var _savedSearchItem = require('./modules/savedSearchItem');

var _savedSearchItem2 = _interopRequireDefault(_savedSearchItem);

var _saveItem = require('./modules/saveItem');

var _saveItem2 = _interopRequireDefault(_saveItem);

var _saveSearch = require('./modules/saveSearch');

var _saveSearch2 = _interopRequireDefault(_saveSearch);

var _saveSearchCheck = require('./modules/saveSearchCheck');

var _saveSearchCheck2 = _interopRequireDefault(_saveSearchCheck);

var _search = require('./modules/search');

var _search2 = _interopRequireDefault(_search);

var _searchFacets = require('./modules/searchFacets');

var _searchFacets2 = _interopRequireDefault(_searchFacets);

var _searchSuggestions = require('./modules/searchSuggestions');

var _searchSuggestions2 = _interopRequireDefault(_searchSuggestions);

var _seller = require('./modules/seller');

var _seller2 = _interopRequireDefault(_seller);

var _sellerCatalogCounts = require('./modules/sellerCatalogCounts');

var _sellerCatalogCounts2 = _interopRequireDefault(_sellerCatalogCounts);

var _sellerDetail = require('./modules/sellerDetail');

var _sellerDetail2 = _interopRequireDefault(_sellerDetail);

var _sellerEndedCatalogs = require('./modules/sellerEndedCatalogs');

var _sellerEndedCatalogs2 = _interopRequireDefault(_sellerEndedCatalogs);

var _sellerRecordResults = require('./modules/sellerRecordResults');

var _sellerRecordResults2 = _interopRequireDefault(_sellerRecordResults);

var _sellerUpcomingCatalogs = require('./modules/sellerUpcomingCatalogs');

var _sellerUpcomingCatalogs2 = _interopRequireDefault(_sellerUpcomingCatalogs);

var _sendSellerMessage = require('./modules/sendSellerMessage');

var _sendSellerMessage2 = _interopRequireDefault(_sendSellerMessage);

var _setPassword = require('./modules/setPassword');

var _setPassword2 = _interopRequireDefault(_setPassword);

var _shouldLogin = require('./modules/shouldLogin');

var _shouldLogin2 = _interopRequireDefault(_shouldLogin);

var _similarItems = require('./modules/similarItems');

var _similarItems2 = _interopRequireDefault(_similarItems);

var _updateAccount = require('./modules/updateAccount');

var _updateAccount2 = _interopRequireDefault(_updateAccount);

var _updatePassword = require('./modules/updatePassword');

var _updatePassword2 = _interopRequireDefault(_updatePassword);

var _user = require('./modules/user');

var _user2 = _interopRequireDefault(_user);

var _viewData = require('./modules/viewData');

var _viewData2 = _interopRequireDefault(_viewData);

var _whiteLabel = require('./modules/whiteLabel');

var _whiteLabel2 = _interopRequireDefault(_whiteLabel);

var _windowSize = require('./modules/windowSize');

var _windowSize2 = _interopRequireDefault(_windowSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    config: _config2.default,
    console: _console2.default,
    domain: (0, _redux.combineReducers)({
        biddingInfo: _biddingInfo2.default,
        bidHistory: _bidHistory2.default,
        bidIncrements: _bidIncrements2.default,
        catalog: _catalog2.default,
        catalogCurators: _catalogCurators2.default,
        catalogDetail: _catalogDetail2.default,
        catalogLocation: _catalogLocation2.default,
        coverLots: _coverLots2.default,
        home: _home2.default,
        item: _item2.default,
        itemDetail: _itemDetail2.default,
        itemFacets: _itemFacets2.default,
        loaded: _loaded2.default,
        savedItemCount: _savedItemCount2.default,
        seller: _seller2.default,
        sellerCatalogCounts: _sellerCatalogCounts2.default,
        sellerDetail: _sellerDetail2.default,
        sellerEndedCatalogs: _sellerEndedCatalogs2.default,
        sellerRecordResults: _sellerRecordResults2.default,
        sellerUpcomingCatalogs: _sellerUpcomingCatalogs2.default,
        similarItems: _similarItems2.default
    }),
    errors: _errors2.default,
    healthcheck: _healthcheck2.default,
    intl: _reactIntlRedux.intlReducer,
    persist: (0, _redux.combineReducers)({
        headerSearchDropdown: _headerSearchDropdown2.default,
        pagination: _pagination.paginationLocalStorageReducer
    }),
    reduxAsyncConnect: _reduxAsyncConnect.reducer,
    route: _route2.default,
    routing: _reactRouterRedux.routerReducer,
    shouldLogin: _shouldLogin2.default,
    ui: (0, _redux.combineReducers)({
        absenteeBid: _absenteeBid2.default,
        analytics: _analytics2.default,
        autoPopModal: _autoPopModal2.default,
        bidderExists: _bidderExists2.default,
        browser: _browser2.default,
        completeAccount: _completeAccount2.default,
        confirmPassword: _confirmPassword2.default,
        consignment: _consignment2.default,
        createAccount: _createAccount2.default,
        fetchBatch: _fetchBatch2.default,
        forgotPassword: _forgotPassword2.default,
        imageGalleryActiveImage: _imageGalleryActiveImage2.default,
        itemDescription: _itemDescription2.default,
        landingPage: _landingPage2.default,
        login: _login2.default,
        modal: _modal2.default,
        moreItemsFromCatalogIndex: _moreItemsFromCatalogIndex2.default,
        pagination: _pagination.paginationCookiesReducer,
        retractBid: _retractBid2.default,
        saveSearch: _saveSearch2.default,
        saveSearchCheck: _saveSearchCheck2.default,
        search: _search2.default,
        searchFacets: _searchFacets2.default,
        searchSuggestions: _searchSuggestions2.default,
        sendSellerMessage: _sendSellerMessage2.default,
        setPassword: _setPassword2.default,
        updateAccount: _updateAccount2.default,
        updatePassword: _updatePassword2.default,
        viewData: _viewData2.default,
        windowSize: _windowSize2.default
    }),
    user: (0, _redux.combineReducers)({
        catalogRegistration: _catalogRegistration2.default,
        emailList: _emailList2.default,
        followSeller: _followSeller2.default,
        registerForCatalog: _registerForCatalog2.default,
        savedSearch: _savedSearch2.default,
        savedSearchItem: _savedSearchItem2.default,
        saveItem: _saveItem2.default,
        user: _user2.default
    }),
    whiteLabel: _whiteLabel2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/rootReducer.js
// module id = PTSw
// module chunks = 46